
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glass?: boolean;
}

export default function Card({ children, className = '', hover = false, glass = false }: CardProps) {
  const baseClasses = 'rounded-xl transition-all duration-300';
  const hoverClasses = hover ? 'hover:shadow-2xl hover:-translate-y-1' : '';
  const glassClasses = glass 
    ? 'bg-white/10 backdrop-blur-md border border-white/20 shadow-xl' 
    : 'bg-white shadow-lg border border-gray-100';

  return (
    <div className={`${baseClasses} ${glassClasses} ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
